import "./WhyChooseCard.css";

const WhyChooseCard = ({ icon: Icon, title, description }) => {
  return (
    <div className="why-card">

      <div className="why-card-icon">
        <Icon size={30} />
      </div>

      <h3>{title}</h3>

      <p>{description}</p>

    </div>
  );
};

export default WhyChooseCard;